export default __webpack_public_path__ + "static/media/catamaran.d5d0c584.jpg";